import React, { useEffect } from 'react';
import RecommendationTabs from '../ViewDetailsPage/RecommendationTab';
import { PageLayout } from '../MainPageStyle';
import { useSelector, useDispatch } from 'react-redux';
import { pushEntityTrendData } from '../../slices/entityTrendLineSlice';
import { getRiskAPIResponseData, getApiResponseData } from '../../services/apiservices';
import { baseUrlRisk, baseUrl } from '../../constants/constants';
import { pushSelectedApplication } from '../../slices/HeatMapSlice';
import { pushSelectedAccount } from '../../slices/ApplicationDrillHeatMapSlice';
import { pushDetailsPageStatusCardData } from '../../slices/DetailsPageStatusCardSlice';
import { pushRiskScoreCardData } from '../../slices/RiskScoreCardSlice';
import { pushRecommendationData } from '../../slices/RecommendationDataSlice';
import { pushSelectedRow } from '../../slices/ResourceDistributionSlice';
import { pushPolicyData, pushImpactResultData } from '../../slices/AccordionDataSlice';
import { pushShowRecommendationTab } from '../../slices/recommendationTableSlice';

const ViewDetails = props => {
  let entityUuid = props.match.params.entityUuid;
  let appIdParam = props.match.params.appId;
  let accountUuid = props.match.params.accountUuid;
  const dispatch = useDispatch();
  const [overallTrendLoading, setOverallTrendLoading] = React.useState(false);

  const handleOverallTrendLoading = overalTrendSpinnerLoading => {
    setOverallTrendLoading(overalTrendSpinnerLoading);
  };

  let paginationString = 'accounts-wise?limit=1000&offset=0&filter=appId=';
  let url = baseUrlRisk + paginationString + appIdParam;
  const accountWiseApiResponseData = useSelector(state => state.recommendationTable.applicationDrillHeatmap);
  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);
  const apiResponseData = useSelector(state => state.recommendationTable.ApplicationResponse);
  const showRecommendationTab = useSelector(state => state.recommendationTable.showRecommendationTab);
  useEffect(() => {
    let statusCardObj = {};
    let rowData = '';

    if (accountWiseApiResponseData && accountWiseApiResponseData.data && accountWiseApiResponseData.data.responseList) {
      let accountWiseData = accountWiseApiResponseData.data.responseList.filter(item => {
        return item.accountUuid === accountUuid;
      });

      if (accountWiseData.length > 0) {
        dispatch(pushSelectedApplication(accountWiseData[0].appName));
        dispatch(pushSelectedAccount(accountWiseData[0].envName));
        statusCardObj['origin'] = accountWiseData[0].appName;
        statusCardObj['envName'] = accountWiseData[0].envName;
      }
    }

    if (riskApiResponseData && riskApiResponseData.data && riskApiResponseData.data.responseList) {
      let overAllRisk = riskApiResponseData.data.responseList;
      let overAllData = overAllRisk.filter(item => {
        return appIdParam === item.appId;
      });

      if (overAllData.length > 0) {
        statusCardObj['overallRiskScore'] = overAllData[0].overallRiskScore;
        statusCardObj['overallRiskCategory'] = overAllData[0].overallRiskCategory;
        statusCardObj['originRiskCategory'] = overAllData[0].originRiskCategory;
        statusCardObj['originRiskScore'] = overAllData[0].originRiskScore;
      }
    }

    if (apiResponseData && apiResponseData.data && apiResponseData.data.responseList) {
      let tableResponse = apiResponseData.data.responseList;
      let tableResData = tableResponse.filter(item => {
        return appIdParam === item.appId;
      });
      rowData = tableResData[0];

      if (tableResData.length > 0) {
        statusCardObj['accountRiskScore'] = tableResData[0].accountRiskScore;
        statusCardObj['accountRiskCategory'] = tableResData[0].accountRiskCategory;
      }
    }

    dispatch(pushShowRecommendationTab(!showRecommendationTab));

    if (rowData) {
      dispatch(pushImpactResultData(rowData.impactResult));
      dispatch(pushPolicyData(rowData));
      dispatch(pushRecommendationData(rowData));
      dispatch(pushSelectedRow(rowData));
    }

    dispatch(pushDetailsPageStatusCardData(statusCardObj));
    dispatch(pushRiskScoreCardData(statusCardObj));
  }, [accountWiseApiResponseData, riskApiResponseData, apiResponseData]);
  useEffect(() => {
    dispatch(getRiskAPIResponseData(url, 'applicationDrillHeatmap'));
  }, []);
  const entityTrendApiResponseData = useSelector(state => state.recommendationTable.entityTrendResponse);
  useEffect(() => {
    let riskUrl = baseUrlRisk + 'entity-trend?filter=entityUuid=' + entityUuid;
    dispatch(getRiskAPIResponseData(riskUrl, 'entityTrendResponse'));
    let paginationStringOrigin = 'origins-wise';
    let riskWiseUrl = baseUrlRisk + paginationStringOrigin;
    dispatch(getRiskAPIResponseData(riskWiseUrl, 'riskResponse'));
    let paginationQueryString = `?filter=appId=${appIdParam},entityUuid=${entityUuid},recoType=Any&limit=10&offset=0&view=recommendation`;
    let exportUrl = baseUrl + paginationQueryString;
    dispatch(getApiResponseData(exportUrl, 'ApplicationResponse'));
  }, []);
  useEffect(() => {
    if (entityTrendApiResponseData && entityTrendApiResponseData.data) {
      let entityTrendLineData = entityTrendApiResponseData.data;
      dispatch(pushEntityTrendData(entityTrendLineData));
      setOverallTrendLoading(true);
    }
  }, [entityTrendApiResponseData]);
  const ResourceDistributionData = useSelector(state => state.ResourceDistribution.dataSet);
  return /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement(RecommendationTabs, {
    isLoading: entityTrendApiResponseData?.isLoading || apiResponseData?.isLoading,
    overallTrendLoading: overallTrendLoading,
    handleOverallTrendLoading: handleOverallTrendLoading,
    ResourceDistributionData: ResourceDistributionData
  }));
};

export default ViewDetails;